import { TabsLayout } from '@/layouts/TabsLayout'
import type { TabNavigationItem } from '@/components/Tabs/TabsNavigation'
import { DistributorWorkspaceProvider } from '@/contexts/DistributorWorkspaceContext'
import { DistributorWorkspaceSelector } from './DistributorWorkspaceSelector'

const TAB_VISAO_GERAL: TabNavigationItem = {
  value: 'visao-geral',
  label: 'Visão Geral',
  icon: 'mdi:view-dashboard-outline',
  to: '/sou-distribuidor',
}

const TAB_AFILIADOS: TabNavigationItem = {
  value: 'afiliados',
  label: 'Meus Afiliados',
  icon: 'mdi:account-group-outline',
  to: '/sou-distribuidor/afiliados/lista',
}

const TAB_SALDO: TabNavigationItem = {
  value: 'saldo',
  label: 'Saldo',
  icon: 'mdi:wallet-outline',
  to: '/sou-distribuidor/saldo',
}

const TABS = [TAB_VISAO_GERAL, TAB_AFILIADOS, TAB_SALDO] as const

function SouDistribuidorTabsLayoutInner() {
  return (
    <TabsLayout
      title="Sou Distribuidor"
      subtitle="Gerencie afiliados, acompanhe vendas e comissões"
      tabs={[...TABS]}
      headerAction={<DistributorWorkspaceSelector />}
    />
  )
}

export function SouDistribuidorTabsLayout() {
  return (
    <DistributorWorkspaceProvider>
      <SouDistribuidorTabsLayoutInner />
    </DistributorWorkspaceProvider>
  )
}
